<template>
  <div class="submit-layout">
    <img class="finishwork" src="@/assets/images/homeWork/finishwork.png" alt="">
    <div class="finishcontent">
      <img src="@/assets/images/homeWork/setting.png" />
      <div class="title">恭喜您完成本次作业</div>
      <div class="sub-title">
        <span>本次部分得分</span>
        <div class="score">
          {{ getScore }}<span>分</span>
        </div>
      </div>
      <div v-if="type !== 'doPractice'" class="tips">简答题分数待老师批阅后可查看</div>
      <div class="feedback-btn">
        <button @click="comfirmBack">返回</button>
      </div>
    </div>
    <!-- <img class="feedback-close" @click="handleCloseSubmitPaper" src="../img/ico_guanbi2@2x.png" /> -->
  </div>
</template>

<script>
export default {
  data () {
    return { }
  },
  props:['totalScore','getScore', 'type'],
  computed: { },
  watch: { },
  methods: {
    comfirmBack(){
      this.$router.go(-1)
    }
   },
  mounted() {
    
   }
}
</script>

<style lang="scss" scoped>
.submit-layout{
  width: 100%;
  height: 100%;
  background: #ffffff;
  position: relative;
  img{
    width: 80px;
    height: 80px;
    margin-bottom: 8px;
  }
  .finishwork {
    width: 100%;
    height: 280px;
    margin-bottom: 0;
    margin-top: 0;
  }
  .finishcontent {
    position: absolute;
    top: 126px;
    left: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title{
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #202020;
  }
  .sub-title{
    font-size: 14px;
    font-weight: 400;
    font-size: 14px;
    color: #888888;
    padding: 24px 54px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: linear-gradient(0deg,#ffffff 0%, #e1eafe);
    border-radius: 16px;
    box-shadow: 0px -4px 16px 0px rgba(0,0,0,0.05);
    border: 1px solid #e1eafe;
  }
  .score{
    font-size: 36px;
    font-weight: 600;
    color: #286BFF;
    margin-top: 8px;
    span{
      font-size: 14px;
      font-weight: 400;
      font-size: 14px;
      margin-left: 4px;
    }
  
  }
  .tips{
    color: #202020;
    font-size: 13px;
    margin-top: 8px;
    font-weight: 400;
  }
  .feedback-btn{
    margin-top: 8px;
    button{
      width: 210px;
      height: 40px;
      background: #EAF1FF;
      border-radius: 22px;
      font-size: 16px;
      color: #286BFF;
      text-align: center;
      line-height: 40px;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }
}
</style>
